<template>
  <div
    class="email-draft"
  >
    <p
      class="alert alert-info text-center fixed-bottom"
      v-if="email.inactive"
      style="margin-bottom: 0"
    >
      This is a draft email!
      <button
        class="btn btn-sm btn-warning ml-1"
        v-on:click="publish"
        v-if="!hidePublish"
      >
        Publish
      </button>
    </p>
  </div>
</template>
<script>
import EmailMixin from '@/mixins/EmailMixin'

export default {
  props: {
    hidePublish: {
      type: Boolean,
      default: false
    }
  },

  mixins: [
    EmailMixin
  ]
}
</script>



// WEBPACK FOOTER //
// src/components/EmailDraft.vue